module.exports = __webpack_public_path__ + "img/xiezhurenyuandb.ef42a422.png";